import React from 'react';
import TestimonialItem from "./TestimonialItem";
import Swiper from 'react-id-swiper';

export default class Testimonials extends React.Component {
    constructor(props) {
        super(props);

        this.swiperRef = React.createRef();

        this.slideNext = this.slideNext.bind(this);
        this.slidePrev = this.slidePrev.bind(this);
    }
    slideNext() {
        if (this.swiperRef.current !== null && this.swiperRef.current.swiper !== null) {
            this.swiperRef.current.swiper.slideNext();
        }
    }
    slidePrev() {
        if (this.swiperRef.current !== null && this.swiperRef.current.swiper !== null) {
            this.swiperRef.current.swiper.slidePrev();
        }
    }
    render() {
        const swiperParams = {
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        };

        return (
            <div className="slider-2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2>Відгуки</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="image-container">
                                <img className="img-fluid" src="/images/testimonials-2-men-talking.svg"
                                     alt="Відгуки" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="slider-container">
                                <div className="swiper-container card-slider">
                                    <Swiper ref={this.swiperRef} {...swiperParams}>
                                        <TestimonialItem
                                            imgSrc="/images/maria.jpg"
                                            text="Доброго дня :) У мене 191 бал )) Все так, як я й хотіла ))
                                                Щиро дякую вам, ви дуже талановитий викладач, усе пояснювали дуже
                                                зрозуміло та виділяли найголовніше)) за 4 місяці вивчити історію з
                                                нуля — це майже неможливо. 😊"
                                            author="Марія Ведмеденко"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/masha.jpg"
                                            text="Дуже дякую за вашу працю!!!! У вас чудові конспекти, усе,
                                                що потрібно і подано дуже цікаво!!!! Велике спасибі за ваші трансляції,
                                                коли була зайнята, завжди їх слухала!!!! Удачі вам! Продовжуйте робити
                                                те, що робите!!! ВЕЛИЧЕЗНЕ ВАМ СПАСИБІ!!!!!"
                                            author="Марія Дуб"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/testimonial-1.svg"
                                            text="Поспішаю повідомити, що написала її краще за всіх! Якби я випадково
                                                не знайшла вашу сторінку та ваші конспекти — навіть не знаю, що було б!
                                                Дякую! За вашу роботу, за неймовірний конспект, за трансляції, за
                                                допомогу в Діректі! Нехай Бог подарує вам багато класних учнів, терпіння
                                                і, головне — не зупиняйтеся, робіть те, що робите! Дякую! ❤️❤️❤️❤️"
                                            author="Аня Колесник"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/vasilieva.jpg"
                                            text="У мене 194 (за ДПА 12). Усе завдяки Вам, величезне спасибі! ❤️❤️❤️❤️
                                                Буду Вас рекомендувати майбутнім одинадцятикласникам💋"
                                            author="Юлія Васильева"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/german.jpg"
                                            text="Дуже дякуємо, дуже зворушені! :) Ми Вам надзвичайно вдячні — без Вас
                                            ми б нічого не зробили ❤️"
                                            author="Іра і Герман Рибак"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/testimonial-3.svg"
                                            text="Олеся, я приблизно написав ЗНО на 165 балів. Як на мене, було
                                                складнувато, але все ж, навіть якщо десь відповів неправильно — це
                                                більше через мою неуважність! А так хочу сказати Вам велике ДЯКУЮ за те,
                                                що допомогли підготуватися до ЗНО! Буду рекомендувати Вас усім як
                                                чудового вчителя. Ще раз дякую! Ви хороший учитель і дуже
                                                доброзичлива людина!"
                                            author="Макс Кузьменко"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/valeria.jpg"
                                            text="У мене 193 бали по ЗНО і 12 по ДПА.
                                                @pidgotovka_do_zno_ - тут кращий викладач з історії"
                                            author="Валерія Бабко"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/liza.jpg"
                                            text="У мене 188. Я задоволена результатом. Дуже дякую за допомогу :)"
                                            author="Ліза Ресенчук"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/sonia.jpg"
                                            text="Дааааааа, ділюсь радістю. У мене 188. Дуже Вам дякую."
                                            author="Соня Дирявко"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/testimonial-3.svg"
                                            text="У мене 184. Велике спасибі. Супер результат по ЗНО"
                                            author="Женя Розсипайло"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/testimonial-3.svg"
                                            text="Як і Макс, буду Вас рекомендувати, якщо комусь знадобиться допомога.
                                                Я написав приблизно на 184 бали, помилки були лише через те, що трохи
                                                призабув дати. А так усе було не надто складно. Дякую, що Ви нас
                                                готували! Хоч я обрав історію як четвертий предмет, мені справді було
                                                цікаво її вивчати з Вашою допомогою. Ще раз дякую!"
                                            author="Віктор Тараненко"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/testimonial-2.svg"
                                            text="Це дуже хороший репетитор, просто чудовий! Я у захваті від
                                                Олесі Анатоліївни! Вона працює дуже професійно. Це педагог найвищого
                                                класу! Репетитор дає чудові знання з історії. Заняття дуже ефективні.
                                                Олеся Анатоліївна готується до занять, подає потрібний матеріал і
                                                пояснює його зрозуміло. Усі мої побажання педагог враховує.
                                                Хочу подякувати Олесі Анатоліївні за чудове навчання сина."
                                            author="Юлія Єрмоленко"
                                        />
                                        <TestimonialItem
                                            imgSrc="/images/testimonial-1.svg"
                                            text="Добрий вечір...Я здала НМТ на 200. Готувалась самостійно,
                                                використовуючи лише ваш «Самостійний курс». Це дуже хороший варіант для
                                                тих хто може працювати сам))Чесно кажучи, якщо сумлінно працювати за
                                                вашими конспектами і робити всі тести, РЕАЛЬНО скласти ЗНО на 200...
                                                Вчила лише потрібне, бо в конспектах нема «води»; все дуже чітко і
                                                лаконічно розписано... допомагав загальний чат і взагалі, вважаю, що
                                                ваш сайт це дуже хороша можливість, дуже зручно і головне ефективно!!!

                                                Тому, щиро всім рекомендую підготовку із zno.dp)"
                                            author="Даша Рацкевич"
                                        />
                                    </Swiper>
                                    <div className="swiper-button-next" onClick={this.slideNext}></div>
                                    <div className="swiper-button-prev" onClick={this.slidePrev}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}